import * as React from 'react';

import { SearchTags } from '../../../../../../../common/components/search_tags';

interface IWordsIncludeProps {
  wordsInclude: string[];
  isModerator: boolean;
  onWordIncludeAdded(word: string): void;
  onWordIncludeRemoved(word: string): void;
}

export const WordsInclude: React.FC<IWordsIncludeProps> = props => (
  <SearchTags
    isModerator={props.isModerator}
    words={props.wordsInclude}
    onWordAdded={props.onWordIncludeAdded}
    onWordRemoved={props.onWordIncludeRemoved}
    tagStyle={{ backgroundColor: 'rgba(45,160,1,.2)', color: '#121212' }}
    placeholder="Например: срочно"
  />
);
